import { render, staticRenderFns } from "./OrbitClaimFormStep.vue?vue&type=template&id=456a88f6&scoped=true"
import script from "./OrbitClaimFormStep.vue?vue&type=script&lang=ts"
export * from "./OrbitClaimFormStep.vue?vue&type=script&lang=ts"
import style0 from "./OrbitClaimFormStep.vue?vue&type=style&index=0&id=456a88f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "456a88f6",
  null
  
)

export default component.exports